import { render } from "./TimeBar.vue?vue&type=template&id=ed0b684e"
import script from "./TimeBar.vue?vue&type=script&lang=js"
export * from "./TimeBar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__